﻿import {HttpClientError} from "@2d-front-monorepo/core";
import {logErrorToServer} from "@2d-front-monorepo/design-library";
import {InstallationId, IPermitsHttpClient, PermitsFrontClient} from "@2d-front-monorepo/permits-business";
import getInstallationId from "../hooks/getInstallationId";
import {GlobalContext} from "./GlobalContext";
import {userStore} from "./UserContext";
import {API_ENDPOINT} from "../api-endpoint";
import {REACT_APP_HOSTNAME} from "../config";

function errorHandler(error: Error): void {
	if (!(error instanceof HttpClientError)) {
		return;
	}

	if (error.status === 401 || error.status === 403) {
		userStore.patchState(x => x.authStatus = "unauthorized");
		return;
	}

	if (error.status === 0 && error.problemDetails.type !== "AbortError") {
		logErrorToServer(`${API_ENDPOINT.errorLogging}?hostName=${REACT_APP_HOSTNAME}`, error);
	}
}

export class HttpContext {
	private static _installationId: InstallationId | undefined = undefined;
	private static _instance: HttpContext | undefined;
	private _client: IPermitsHttpClient;

	private constructor(installationId?: InstallationId) {
		this._client = this.createClient(installationId);
	}

	static getClient(installationId?: InstallationId): IPermitsHttpClient {
		return HttpContext.getInstance(installationId)._client;
	}

	static reset(): void {
		this._instance = undefined;
	}

	private static getInstance(installationId?: InstallationId): HttpContext {
		if (this._installationId != null && this._instance != null) {
			return this._instance;
		}

		this._installationId = installationId ?? getInstallationId();
		return this._instance = new HttpContext(this._installationId);
	}

	private createClient(installationId?: InstallationId): IPermitsHttpClient {
		return new PermitsFrontClient(API_ENDPOINT.root, installationId, errorHandler, () => GlobalContext.tryGetData()?.now() ?? null);
	}
}
